import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppCommonModule } from '../../common.module';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AppCommonModule,
  ],
})
export class LogoComponent {
  @Input()
  public height: string = '30px';

  @Input()
  public width: string = 'auto';

  @Input()
  public color: 'dark' | 'light' = 'dark';
}
